module.exports = __webpack_public_path__ + "player/chiptune2.js";